import type { PropsWithChildren } from 'react';

import type { Button } from '@xing-com/button';
import type { Link } from '@xing-com/link';

type TrackingLinkProps = {
  url: string;
  as: typeof Link | typeof Button | React.ElementType;
  trackingParams: Record<string, string>;
  [componentParams: string]: unknown;
};

const joinParams = (params: Record<string, string>): string =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

export const TrackingLink: React.FC<PropsWithChildren<TrackingLinkProps>> = ({
  children,
  url,
  as,
  trackingParams,
  ...componentParams
}) => {
  const Component = as;

  const addQuestionMark = url.includes('?') ? '&' : '?';
  const urlWithTracking = `${url}${addQuestionMark}${joinParams(
    trackingParams
  )}`;

  const onClick = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>
  ): void => {
    e.preventDefault();

    window.open(urlWithTracking, '_blank', 'noopener,noreferrer');
  };

  return (
    <Component {...componentParams} href={url} to={url} onClick={onClick}>
      {children}
    </Component>
  );
};
